import React, { forwardRef } from 'react'

const ComponentToPrintCode = forwardRef(({ item }, ref) => (
    <div ref={ref} style={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '20px'
    }}>
        <b>
            <div style={{ fontWeight: 'bold', fontSize: '54px', marginTop: '5px' }}>
                {item.name || 'No Name'} <br />  <i><span>{item.code || ''}</span></i>
            </div>
        </b>
    </div>

))

export default ComponentToPrintCode
